(function () {
  function fix() {
    Array.prototype.forEach.call(document.querySelectorAll('main img, footer img'), function (img) {
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
      if (!img.getAttribute('alt')) {
        var s = img.closest('.slideshow__slide');
        var t = '';
        if (s) { var b = s.querySelector('.button, a'); t = b ? b.textContent.trim() : ''; }
        img.setAttribute('alt', t ? t.charAt(0).toUpperCase() + t.slice(1).toLowerCase() + ' · Landa Brands' : 'Landa Brands');
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      if (!v.autoplay && v.getAttribute('preload') !== 'none') v.setAttribute('preload', 'none');
    });
  }
  document.addEventListener('DOMContentLoaded', fix);
  window.addEventListener('load', fix);
})();
